import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const getChargebeePlanSettings = graphql.query<
    GetChargebeePlanSettingsQuery,
    GetChargebeePlanSettingsQueryVariables
>('getChargebeePlanSettings', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                getChargebeePlanSettings: [
                    {
                        id: 'CHARGEBEE_PLAN_SCALE' as ChargebeePlanId,
                        chargebee_plan_id: 'scale-plan',
                        display_name: 'SCALE',
                        BASE_COST: 170,
                        DETECTION_COST_PER_TRACK: 0.4,
                        DETECTION_TRACKS_INCLUDED: 125,
                        DETECTION_TRACKS_MAX: 1000,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 100000000,
                        ROYALTY_DOLLARS_MAX: 100000000,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_LITE' as ChargebeePlanId,
                        chargebee_plan_id: 'lite-plan',
                        display_name: 'LITE',
                        BASE_COST: 30,
                        DETECTION_COST_PER_TRACK: 0.4,
                        DETECTION_TRACKS_INCLUDED: 50,
                        DETECTION_TRACKS_MAX: 1000,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 2500,
                        ROYALTY_DOLLARS_MAX: 2500,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_NEW_PRO' as ChargebeePlanId,
                        chargebee_plan_id: 'new-pro-plan',
                        display_name: 'PRO',
                        BASE_COST: 90,
                        DETECTION_COST_PER_TRACK: 0.4,
                        DETECTION_TRACKS_INCLUDED: 100,
                        DETECTION_TRACKS_MAX: 1000,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 10000,
                        ROYALTY_DOLLARS_MAX: 10000,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_PUBLISHER' as ChargebeePlanId,
                        chargebee_plan_id: 'publisher-plan',
                        display_name: 'PUBLISHER',
                        BASE_COST: 170,
                        DETECTION_COST_PER_TRACK: null,
                        DETECTION_TRACKS_INCLUDED: 0,
                        DETECTION_TRACKS_MAX: 0,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 100000000,
                        ROYALTY_DOLLARS_MAX: 100000000,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_TRIAL' as ChargebeePlanId,
                        chargebee_plan_id: 'trial',
                        display_name: 'TRIAL',
                        BASE_COST: 0,
                        DETECTION_COST_PER_TRACK: null,
                        DETECTION_TRACKS_INCLUDED: 20,
                        DETECTION_TRACKS_MAX: 20,
                        ROYALTY_COST_PER_DOLLAR: null,
                        ROYALTY_DOLLARS_INCLUDED: 500000,
                        ROYALTY_DOLLARS_MAX: 500000,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_RISE' as ChargebeePlanId,
                        chargebee_plan_id: 'rise-plan',
                        display_name: 'RISE',
                        BASE_COST: 50,
                        DETECTION_COST_PER_TRACK: 0.4,
                        DETECTION_TRACKS_INCLUDED: 75,
                        DETECTION_TRACKS_MAX: 1000,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 5000,
                        ROYALTY_DOLLARS_MAX: 5000,
                        __typename: 'chargebeePlanSettings',
                    },
                    {
                        id: 'CHARGEBEE_PLAN_NEW_BASIC' as ChargebeePlanId,
                        chargebee_plan_id: 'new-basic-plan',
                        display_name: 'BASIC',
                        BASE_COST: 0,
                        DETECTION_COST_PER_TRACK: 0.4,
                        DETECTION_TRACKS_INCLUDED: 0,
                        DETECTION_TRACKS_MAX: 1000,
                        ROYALTY_COST_PER_DOLLAR: 0,
                        ROYALTY_DOLLARS_INCLUDED: 1000,
                        ROYALTY_DOLLARS_MAX: 1000,
                        __typename: 'chargebeePlanSettings',
                    },
                ],
            }),
        );
    }

    return res();
});
